module.exports = {"absorb":"","block":"","deflect":"","dodge":"","evade":"","immune":"","miss":"","parry":"","reflect":"","resist":"","interrupt":""};